<app-title-component [data]="{name : 'Profils & Droits'}"></app-title-component>

<mat-card appearance="outlined" class="main-table-card border-0 shadow-sm mt-5">
    <mat-card-header class="d-flex align-items-center justify-content-end p-3 border-bottom">
      <div class="mx-2 mt-4">
        <app-search-bar-component (searchBarValue)="applyFilter($event)"></app-search-bar-component>
      </div>
      <button class="btn-add px-4 py-4 fw-semibold" (click)="openAddProfilModal()" matTooltip="Nouveau profil" mat-flat-button color="primary">
        <mat-icon>add</mat-icon>
        <span>Ajouter</span>
      </button>
  </mat-card-header>

<mat-card-content class="position-relative p-0 bg-white">
  
  <!-- Overlay de chargement fluide et flouté -->
  @if (loading()) {
    <div class="table-loading-overlay d-flex align-items-center justify-content-center">
      <mat-spinner diameter="48" color="primary"></mat-spinner>
    </div>
  }

  <mat-accordion class="custom-modern-accordion d-flex flex-column gap-2 p-3 bg-light">
    @for (profil of profils(); track $index) {
      <mat-expansion-panel class="profile-panel border shadow-sm rounded-3 overflow-hidden">
        
        <mat-expansion-panel-header class="py-3 px-3">
          <mat-panel-title class="fw-bold text-dark fs-6">
            {{ profil.name | titlecase }}
          </mat-panel-title>
          
          <mat-panel-description class="text-muted small d-none d-md-flex align-items-center flex-grow-1">
            {{ allRightIsAcive(profil) ? 'Tous les droits sont actifs' : '' }}
          </mat-panel-description>
          
          <!-- Zone d'actions en-tête alignée -->
          <div class="header-actions-group d-flex align-items-center gap-3 ms-auto">
            <mat-slide-toggle
              [matTooltip]="allRightIsAcive(profil) ? 'Désactiver tous les droits' : 'Activer tous les droits'"
              (change)="onChangeRigthsProfil(profil.id, $event.checked)"
              (click)="$event.stopPropagation()"
              [checked]="allRightIsAcive(profil)"
              class="custom-toggle-sm">
            </mat-slide-toggle>
            
            <div class="vertical-divider d-none d-sm-block"></div>

            <button type="button"
              [matTooltip]="'Modifier le profil ' + profil.name"
              (click)="openUpdate(profil); $event.stopPropagation()"
              mat-icon-button color="primary">
              <mat-icon class="text-primary-icon">edit</mat-icon>
            </button>

            <button type="button"
              [matTooltip]="'Supprimer le profil ' + profil.name"
              (click)="confirmDelete(profil); $event.stopPropagation()"
              mat-icon-button color="warn">
              <mat-icon>delete_outline</mat-icon>
            </button>
          </div>
        </mat-expansion-panel-header>

        <!-- Liste des droits internes stylisée en grille de lignes -->
        <mat-nav-list class="p-0 border-top bg-white">
          @for (d of droits; track $index) {
            <div class="d-flex align-items-center justify-content-between px-4 py-2.5 right-item-row">
              <div class="d-flex flex-column">
                <span class="fw-semibold text-dark small-title">{{ d.title | titlecase }}</span>
                <span class="text-muted extra-small-code font-monospace">{{ d.droit }}</span>
              </div>
              <mat-slide-toggle 
                (click)="onChangeRigth(profil.id, d.droit)" 
                [checked]="profil[d.droit]"
                class="custom-toggle-sm">
              </mat-slide-toggle>
            </div>
            <mat-divider></mat-divider>
          }
        </mat-nav-list>

      </mat-expansion-panel>
    } @empty {
      <div class="p-4 text-center">
        <div class="alert alert-custom-info d-inline-flex align-items-center px-4 py-3 rounded-3" role="alert">
          <mat-icon class="me-2 text-info-icon">search_off</mat-icon>
          <span class="fw-medium">Aucun profil ne correspond à : <strong>"{{ searchValue() }}"</strong></span>
        </div>
      </div>
    }
  </mat-accordion>

</mat-card-content>


  <div class="border-top bg-white">

  </div>
</mat-card>
